// extracted by mini-css-extract-plugin
module.exports = {"container":"_32kQxUjZXKB-5eyB_aPhTF"};